import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const LEGAL_PAGES = {
  terms: {
    title: "Terms & Conditions",
    sections: [
      {
        heading: "Overview",
        paragraphs: [
          "Indorinama provides designing, marketing, and promotional services through its website and support channels. By using the site, submitting an enquiry, or placing an order, you agree to these terms.",
          "Service timelines, deliverables, and pricing may vary depending on the selected service, quantity, approvals, and client-side inputs.",
        ],
      },
      {
        heading: "Orders and approvals",
        paragraphs: [
          "Orders move forward based on the scope selected on the website, quotation approval, or direct confirmation over official Indorinama communication channels.",
          "Clients are responsible for reviewing quotations, creative details, names, phone numbers, addresses, and any other submitted information before final approval.",
        ],
      },
      {
        heading: "Payments",
        paragraphs: [
          "Payments made on the website or through approved Indorinama payment methods are treated as authorization to begin service processing.",
          "Taxes, including GST where applicable, may be charged in addition to the listed service amount.",
        ],
      },
      {
        heading: "Service delivery",
        paragraphs: [
          "Delivery timelines depend on the type of work, material readiness, approval speed, and third-party execution requirements where applicable.",
          "Indorinama may pause processing where required information, assets, or approvals are not provided by the client.",
        ],
      },
      {
        heading: "Contact",
        paragraphs: [
          "For order, billing, or policy questions, contact help@indorinama.in or call +91 89898 01088.",
        ],
      },
    ],
  },
  privacy: {
    title: "Privacy Policy",
    sections: [
      {
        heading: "Information we collect",
        paragraphs: [
          "We may collect information such as name, phone number, email address, business details, billing information, and order-related inputs when you contact us, register, request a quotation, or place an order.",
          "We may also collect basic technical information such as browser type, device information, and usage data to improve website performance and support.",
        ],
      },
      {
        heading: "How we use information",
        paragraphs: [
          "We use the information provided to process enquiries and orders, share quotations, provide customer support, improve services, and communicate updates related to your requests.",
          "We do not sell personal information to third parties for independent marketing use.",
        ],
      },
      {
        heading: "Data protection",
        paragraphs: [
          "We use reasonable administrative and technical measures to protect submitted information against unauthorized access, misuse, or disclosure.",
          "Payment processing may involve approved third-party providers, and their systems may apply their own privacy and security controls.",
        ],
      },
      {
        heading: "Cookies and analytics",
        paragraphs: [
          "The website may use cookies or analytics tools to understand traffic, improve user experience, and monitor site performance.",
        ],
      },
      {
        heading: "Contact",
        paragraphs: [
          "Questions about privacy can be sent to help@indorinama.in.",
        ],
      },
    ],
  },
  refund: {
    title: "Refund & Cancellation Policy",
    sections: [
      {
        heading: "Service cancellations",
        paragraphs: [
          "Cancellation requests should be raised as early as possible through official Indorinama support channels.",
          "If work has already started, refunds may be reduced or declined based on the effort, design time, production cost, booking commitment, or third-party charges already incurred.",
        ],
      },
      {
        heading: "Refund eligibility",
        paragraphs: [
          "Refunds, where approved, are generally considered only for duplicate payments, failed processing, or cases where Indorinama is unable to deliver the accepted scope.",
          "Approved refunds are processed back to the original payment source wherever possible, subject to banking or payment partner timelines.",
        ],
      },
      {
        heading: "Non-refundable cases",
        paragraphs: [
          "Amounts related to completed creative work, confirmed bookings, approved deliverables, or third-party execution commitments may be non-refundable.",
        ],
      },
      {
        heading: "Contact",
        paragraphs: [
          "For cancellation or refund requests, contact help@indorinama.in with your order or quotation details.",
        ],
      },
    ],
  },
};

function LegalPage({ page }) {
  const content = LEGAL_PAGES[page] || LEGAL_PAGES.terms;

  return (
    <div className="homepage">
      <Navbar />
      <div
        className="terms-conditions col-lg-10 card mx-auto my-4 rounded border p-4"
        style={{
          background: "rgba(255, 255, 255, 0.1)",
          backdropFilter: "blur(1px)",
        }}
      >
        <h2 className="mb-4 text-center">{content.title}</h2>
        {content.sections.map((section) => (
          <section key={section.heading} className="mb-4">
            <h4>{section.heading}</h4>
            {section.paragraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </section>
        ))}
      </div>
      <Footer />
    </div>
  );
}

export default LegalPage;
